/*
  KAT 07.10.2026 - Hizli sepet (ana sayfa "One Cikan Urunler") duzeltmesi.
  sk-best-sellers bolumu urunu sepete ekleyip 'cart:refresh' olayi gonderiyor
  ama yan sepet (cart drawer) yenilenmiyordu; sayac 1 gosterirken sepet bos
  gorunuyordu. Bu dosya olayi dinler, yan sepeti ve sayaci sunucudan
  guncel haliyle yeniden cizer ve yan sepeti acar.
*/
(function () {
  var busy = false;

  document.addEventListener('cart:refresh', function () {
    if (busy) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    busy = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + '?sections=cart-drawer,cart-counter', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Sepet yenilenemedi');
        return response.json();
      })
      .then(function (sections) {
        drawer.renderContents({ sections: sections });
      })
      .catch(function (error) {
        console.error('[sk-cart-refresh]', error);
      })
      .then(function () {
        busy = false;
      });
  });
})();
